import React, {useEffect, useState} from "react";
import DashboardLayout from "../../../layouts/Dashboard";

import DictionaryCRUDTable from "../../../components/CRUD/Tables/DictionaryCRUDTable";

const ServiceScheduleList = () => {    
    return (
        <DashboardLayout>
            <DictionaryCRUDTable
                entityType="serviceSchedule"
                hasCode={true}
                hasDescription={true}
            />
        </DashboardLayout>
    )
};

export default ServiceScheduleList;
